/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, Divider, Tabs, Tab, Switch, TextField, Button, FormControl, FormHelperText,InputLabel, Select, MenuItem, IconButton, FormControlLabel, Checkbox, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core'
import { Clear, DeleteOutline, TimerSharp } from '@material-ui/icons';
import FlexFormGenerator from '../../../FlexFormGenerator/FlexFormGenerator'
import { v4 as uuidv4 } from 'uuid';

const AntTabs = withStyles({
    root: {
      borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
      backgroundColor: '#1890ff',
    },
})(Tabs);

const AntTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        minWidth: 72,
        fontWeight: theme.typography.fontWeightRegular,
        marginRight: theme.spacing(2),
        padding : theme.spacing(1),
        fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
        ].join(','),
        '&:hover': {
        color: '#40a9ff',
        opacity: 1,
        },
        '&$selected': {
        color: '#1890ff',
        fontWeight: theme.typography.fontWeightMedium,
        },
        '&:focus': {
        color: '#40a9ff',
        },
    },
    selected: {},
}))((props) => <Tab disableRipple {...props} />);

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

const screen_cta_temp = {
    button_label : "Action",
    post_to_parent : false,
    trigger_url : "https://sainapse.ai/",
    user_input : [],
    fields : [
        {
            id : "",
            field_name : "name1",
            source : "native.raw_field",
            mapped_to : "subj"
        },
        {
            id : "",
            field_name : "name2",
            source : "native.world_view",
            mapped_to : "subject"
        },
        {
            id : "",
            field_name : "name3",
            source : "external.raw_field",
            mapped_to : "ticket_id"
        },
        {
            id : "",
            field_name : "name4",
            source : "custom.static",
            mapped_to : "Custom Value Here"
        }
    ]
}

const cta_temp = [
    {
        ic_name : "IC",
        iu : [
            {
                iu_name : "IU Name",
                button_label : "Action",
                post_to_parent : false,
                trigger_url : "https://sainapse.ai/",
                user_input : [],
                fields : [
                    {
                        id : "",
                        field_name : "name1",
                        source : "native.raw_field",
                        mapped_to : "subj"
                    },
                    {
                        id : "",
                        field_name : "name2",
                        source : "native.world_view",
                        mapped_to : "subject"
                    },
                    {
                        id : "",
                        field_name : "name3",
                        source : "external.raw_field",
                        mapped_to : "ticket_id"
                    },
                    {
                        id : "",
                        field_name : "name4",
                        source : "custom.static",
                        mapped_to : "Custom Value Here"
                    }
                ],
            }
        ]
    }
]

const styles = theme => ({})
class CTAConfig extends Component {
    contentHeight = React.createRef();
    state = {
        main_tab_index : 0,
        ic_tab_index : 0,
        iu_tab_index : 0,
        config_tab_index : 0,
        cta_config : [],
        screen_cta_config : [],
        form : [],
        screen_form : [],
        binding_keys : [],
        tab_height : null
    } 

    componentDidMount () {
        const tab_height = this.contentHeight.current.clientHeight
        this.setState({...this.state, tab_height : tab_height})
    }

    handleMainTabChange = (event, newValue) => {
        this.setState({...this.state, main_tab_index : newValue})
    }

    handleTabChange = (event, newValue) => {
        this.setState({...this.state, ic_tab_index : newValue, iu_tab_index : 0})
    }

    handleIUTabChange = (event, newValue) => {
        this.setState({...this.state, iu_tab_index : newValue, config_tab_index : 0})
    }
    handleConfigTabChange = (event, newValue) => {
        this.setState({...this.state, config_tab_index : newValue})
    }

    renderTabs = () => {
        return (
            <div>
                <AntTabs
                    key = 'ic_tab'
                    value={this.state.ic_tab_index}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.handleTabChange}
                    aria-label="Display Config Tabs"
                >
                    {this.props.selected_ic_list.map(ic => {
                        return (
                            <AntTab label = {ic}/>
                        )
                    })}
                </AntTabs>
                {this.renderICTabContent()}
            </div>
        )
    }

    renderICTabContent = () => {
        let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
        let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
        console.log("CTA Screen :: IU List :: ", iu_list)
        return (
            <div style = {{width : '100%', height : '50vh',display : 'flex', flexDirection : 'row'}}>
                <div style = {{width : '20%', borderRight : '1px solid rgba(0,0,0,0.12)', borderLeft : '1px solid rgba(0,0,0,0.12)'}}>
                    <Typography style = {{display : 'block', margin: '5px'}} variant = 'subtitle2'>Information Units</Typography>
                    <Divider/>
                    <AntTabs
                        orientation="vertical"
                        variant="scrollable"
                        value={this.state.iu_tab_index}
                        onChange={this.handleIUTabChange}
                    >
                        {iu_list.map(iu => {
                            return (
                                <AntTab label = {iu}/>
                            )
                        })}
                    </AntTabs>
                </div>
                <div style = {{width : '80%'}}>
                    {this.renderCTAConfig()}
                </div>
            </div>
        )
    }

    renderCTAConfig = () => {
        return (
            <div style = {{width : '100%', maxHeight : '100%'}}>
                <Typography style = {{display : 'block', margin: '5px'}} variant = 'subtitle2'>Configuration</Typography>
                <Divider/>
                <AntTabs
                    key = 'config_tab'
                    value={this.state.config_tab_index}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.handleConfigTabChange}
                    aria-label="Display Config Tabs"
                >
                    <AntTab label = "Target"/>
                    {this.state.main_tab_index !== 0 && <AntTab label = "Field Maps"/>}
                    <AntTab label = "User Input"/>
                </AntTabs>
                {this.renderConfigTabs()}
                {/* {this.getEnableState() && this.renderButtonLabel()}
                {this.getEnableState() && this.renderActionSettings()}
                {this.getEnableState() && this.renderFieldMaps()} */}
            </div>
        )
    }

    renderConfigTabs = () => {
        if (this.state.main_tab_index === 0) {
            switch (this.state.config_tab_index) {
                case 0 : 
                    return this.renderTargetTab()
                case 1 : 
                    return this.renderUserInput()    
                default :
                    return null
    
            }
        } else {
            switch (this.state.config_tab_index) {
                case 0 : 
                    return this.renderTargetTab()
                case 1 : 
                    return this.renderFieldMaps()
                case 2 :
                    return this.renderUserInput()
                default :
                    return null
    
            }
        }
    }

    renderTargetTab = () => {
        return (
            <div ref={this.contentHeight}>
                <div style = {{width : '100%', display : 'flex', padding : '10px',flexDirection : 'row', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                    <Typography style = {{flexGrow : 1}} variant = 'body1'>Enable Call To Action</Typography>
                    <Switch
                        checked = {this.getEnableState()}
                        name = "enable_cta"
                        size = 'small'
                        onChange = {this.toggleCTA}
                        disabled = {!this.props.edit}
                    />
                </div>
                {this.getEnableState() && this.renderButtonLabel()}
                {this.getEnableState() && this.renderActionSettings()}
            </div>    
        )    
    }

    updateParent = (form) => {
        if (this.state.main_tab_index === 0) {
            let screen_cta_config = {...this.props.screen_cta_config}
            let user_input_list = screen_cta_config.user_input? screen_cta_config.user_input:[]
            form.map((input)=>{
                let user_input_index = user_input_list.findIndex(field => field.id === input.id)
                if (input.name !== "" && input.component !== null) {
                user_input_index !== -1 ? screen_cta_config.user_input[user_input_index] = input : screen_cta_config.user_input.push(input)
                } else {
                    if (user_input_index !== -1) screen_cta_config.user_input.splice(user_input_index)
                }
            })
            //this.setState({...this.state,cta_config : cta_config})
            this.props.set_screen_cta(screen_cta_config)

        } else {
            console.log("userinput:", form)
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])
            let user_input_list = cta_config[ic_cta_index].iu[iu_cta_index].user_input? cta_config[ic_cta_index].iu[iu_cta_index].user_input:[]
            form.map((input)=>{
                let user_input_index = user_input_list.findIndex(field => field.id === input.id)
                if(input.name !== "" && input.component !== null) {
                user_input_index !== -1 ? cta_config[ic_cta_index].iu[iu_cta_index].user_input[user_input_index] = input : cta_config[ic_cta_index].iu[iu_cta_index].user_input.push(input)
                } else {
                    if (user_input_index !== -1) cta_config[ic_cta_index].iu[iu_cta_index].user_input.splice(user_input_index)
                }
            })
            //this.setState({...this.state,cta_config : cta_config})
            this.props.set_cta(cta_config) 
        }
    }
    
    getUserInputs=()=>{
        if (this.state.main_tab_index === 0) {
            let screen_cta_config = {...this.props.screen_cta_config}
            return screen_cta_config.user_input ? screen_cta_config.user_input : []
        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])
            return cta_config[ic_cta_index].iu[iu_cta_index].user_input ? cta_config[ic_cta_index].iu[iu_cta_index].user_input : []
        }
    }

    deleteUserInput = (id) => {
        if (this.state.main_tab_index === 0) {
            let screen_cta_config = {...this.props.screen_cta_config}
            let index = screen_cta_config.user_input.findIndex(field => field.id === id)
            screen_cta_config.user_input.splice(index,1)
            this.setState({...this.state, screen_cta_config : screen_cta_config})
        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])
            let user_input_list = cta_config[ic_cta_index].iu[iu_cta_index].user_input? cta_config[ic_cta_index].iu[iu_cta_index].user_input:[]
            let index = user_input_list.findIndex(field => field.id === id)
            cta_config[ic_cta_index].iu[iu_cta_index].user_input.splice(index,1)   
            this.setState({...this.state,cta_config : cta_config}) 
        }
    }
    
    renderUserInput = () => {
        if(this.getEnableState()) {
            return ( 
                <div  style={{width:'100%', height:'100%', display:'flex'}}> 
                    <div style={{ width:'50%', overflow:'auto', height:'100%'}}> 
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Options</TableCell>
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {this.getUserInputs().map((field)=>{
                                let options=field.component_params.findIndex(index=>index.name ==='options')
                                return (
                                    <TableRow>
                                        <TableCell>{field.name}</TableCell>
                                        <TableCell>{field.component}</TableCell>
                                        {
                                           options!==-1?<TableCell>{field.component_params[options].value['list']?field.component_params[options].value['list'].map(item => item.value).join(', '):null}</TableCell>:
                                           <TableCell></TableCell>
                                        }
                                        
                                        <TableCell>
                                            <IconButton onClick={()=>this.deleteUserInput(field.id)} style={{color : this.props.edit?'#f44336':"rgb(0,0,0,0.3)"}} disabled={!this.props.edit}>
                                                <DeleteOutline fontSize='small'></DeleteOutline>
                                            </IconButton>
                                        </TableCell>
                                </TableRow>
                                )
                            })}
                            </TableBody>                 
                        </Table>
                        
                    </div>   
                    <Divider orientation="vertical" variant="middle" flexItem />
                    {this.props.edit && <div style={{ width:'50%', overflow:'auto', maxHeight:'400px'}}>
                        <FlexFormGenerator config = {this.state.form} heading = "Create user input form" binding_keys = {this.state.binding_keys} updateParent = {(form) => {this.updateParent(form)}}/>
                    </div>}
                </div>
            )
        } else {
            return (
                <ThemeProvider theme={blue_theme}>
                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "180px"}}>
                    <Typography color="secondary" variant="caption"> Call to Action is not enabled </Typography>
                  </div>
                </ThemeProvider>
            );
        }
    }

    getEnableState = () => {
        if (this.state.main_tab_index === 0) {
            if (this.props.screen_cta_config) {
                let config_keys = Object.keys(this.props.screen_cta_config)
                if (config_keys.length === 0) {
                    return false
                } else {
                    return true
                }
            } else {
                return false
            }
        } else {
            let ic_cta_index = this.props.cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])

            if (ic_cta_index === -1) {
                return false
            } else {
                let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
                let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
                let ic_cta_config = this.props.cta_config[ic_cta_index]
                let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])
                if (iu_cta_index === -1) {
                    return false
                } else {
                    return true
                }
            }
        }
    }

    toggleCTA = (event) => {
        if (this.state.main_tab_index === 0) {
            if (this.props.screen_cta_config) {
                this.props.set_screen_cta(null)
            } else {
                let screen_cta_config = {
                    button_label : "Action",
                    post_to_parent : false,
                    trigger_url : "https://sainapse.ai/",
                    user_input : []
                }

                this.props.set_screen_cta(screen_cta_config)
            }
        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)

            if (ic_cta_index === -1) {
                if (event.target.checked) {
                    let ic_cta_config = {
                        ic_name : ic_name,
                        iu : [
                            {
                                iu_name : iu_list[this.state.iu_tab_index],
                                button_label : "Action",
                                post_to_parent : false,
                                open_in_new_window : false,
                                trigger_url : "https://sainapse.ai/",
                                fields : [],
                                user_input : []
                            }
                        ]
                    }
                    cta_config.push(ic_cta_config)
                    this.props.set_cta(cta_config)
                }
            } else {
                let ic_cta_config = cta_config[ic_cta_index]
                let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])

                if (iu_cta_index === -1) {
                    if (event.target.checked) {
                        let iu_cta_config = {
                            iu_name : iu_list[this.state.iu_tab_index],
                            button_label : "Action",
                            post_to_parent : false,
                            open_in_new_window : false,
                            trigger_url : "https://sainapse.ai/",
                            fields : [],
                            user_input : []
                        }

                        ic_cta_config.iu.push(iu_cta_config)
                        cta_config[ic_cta_index] = ic_cta_config
                        this.props.set_cta(cta_config)
                    }
                } else {
                    if (!event.target.checked) {
                        ic_cta_config.iu.splice(iu_cta_index, 1)
                        cta_config[ic_cta_index] = ic_cta_config
                        this.props.set_cta(cta_config)
                    }
                }
            }
        }
    }

    renderButtonLabel = () => {
        return (   
            <div>
                <TextField
                    style = {{margin : '10px', width : '98%'}}
                    id="cta-button-label"
                    label="Button Label"
                    value={this.getButtonLabel()}
                    onChange={this.changeButtonLabel}
                    variant="filled"
                    helperText = "Add a label for the button"
                    error = {this.getButtonLabel() === "" ? true : false}
                    required
                    size = 'small'
                    disabled = {!this.props.edit}
                />
                <Divider/>
            </div>
        )
    }

    getButtonLabel = () => {
        if (this.state.main_tab_index === 0) {
            let screen_cta_config = {...this.props.screen_cta_config}
            return screen_cta_config.button_label
        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])
            return cta_config[ic_cta_index].iu[iu_cta_index].button_label
        }
    }

    changeButtonLabel = (event) => {
        if (this.state.main_tab_index === 0) {
            let screen_cta_config = {...this.props.screen_cta_config}
            screen_cta_config.button_label = event.target.value
            this.props.set_screen_cta(screen_cta_config)
        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])

            cta_config[ic_cta_index].iu[iu_cta_index].button_label = event.target.value
            this.props.set_cta(cta_config)
        }
    }

    renderActionSettings = () => {
        return (
            <div style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center', marginTop: '10px', marginBottom : '10px', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                <div style = {{width : '60%', display : 'flex', flexDirection : 'row', flexWrap : 'wrap'}}>
                    <div style = {{flexGrow: 1}}>
                        <Typography display='inline' style = {{margin: '10px'}} variant = 'body1'>Post Message to Parent Window</Typography>
                        <Switch
                            checked = {this.getPost2ParentState()}
                            name = "post_to_parent"
                            size = 'small'
                            onChange = {this.togglePost2Parent}
                            disabled = {!this.props.edit}
                        />
                    </div>
                    <div style = {{flexGrow: 1}}>
                            <FormControlLabel
                                disabled = {!this.props.edit || this.getPost2ParentState() === true}
                                control={
                                    <Checkbox
                                      checked={this.getWindowState()}
                                      onChange={this.updateWindowState}
                                      name="open_in_new_window"
                                      color="primary"
                                    />
                                  }
                                label="Open in new window"
                            />
                        </div>
                </div>

                {!this.getPost2ParentState() && <div style = {{width : '40%'}}>
                    <TextField
                        fullWidth
                        id="cta-trigger-url"
                        label="Trigger URL"
                        value={this.getTriggerURL()}
                        onChange={this.changeTriggerURL}
                        variant="filled"
                        helperText = "The URL to be called. The fields will be added as Query Params."
                        error = {this.getTriggerURL() === "" ? true : false}
                        required
                        size = 'small'
                        disabled = {!this.props.edit}
                    />
                </div>}
            </div>
        )
    }

    getWindowState = () => {
        if (this.state.main_tab_index === 0) {
            return this.props.screen_cta_config.open_in_new_window

        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])
            return cta_config[ic_cta_index].iu[iu_cta_index].open_in_new_window
        }
    }

    updateWindowState = (event) => {
        if (this.state.main_tab_index === 0) {
            let screen_cta_config = this.props.screen_cta_config
            screen_cta_config.open_in_new_window = event.target.checked
            this.props.set_screen_cta(screen_cta_config)

        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])

            cta_config[ic_cta_index].iu[iu_cta_index].open_in_new_window = event.target.checked
            this.props.set_cta(cta_config)
        }
    }

    getPost2ParentState = () => {
        if (this.state.main_tab_index === 0) {
            return this.props.screen_cta_config.post_to_parent

        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])
            return cta_config[ic_cta_index].iu[iu_cta_index].post_to_parent
        }
    }

    togglePost2Parent = (event) => {
        if (this.state.main_tab_index === 0) {
            let screen_cta_config = this.props.screen_cta_config
            screen_cta_config.post_to_parent = event.target.checked
            screen_cta_config.open_in_new_window = event.target.checked === true ? false : screen_cta_config.open_in_new_window
            this.props.set_screen_cta(screen_cta_config)

        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])

            cta_config[ic_cta_index].iu[iu_cta_index].post_to_parent = event.target.checked
            this.props.set_cta(cta_config)
        }
    }

    getTriggerURL = () => {
        if (this.state.main_tab_index === 0) {
            return this.props.screen_cta_config.trigger_url

        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])
            return cta_config[ic_cta_index].iu[iu_cta_index].trigger_url
        }
    }

    changeTriggerURL = (event) => {
        if (this.state.main_tab_index === 0) {
            let screen_cta_config = this.props.screen_cta_config
            screen_cta_config.trigger_url = event.target.value
            this.props.set_screen_cta(screen_cta_config)

        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])

            cta_config[ic_cta_index].iu[iu_cta_index].trigger_url = event.target.value
            this.props.set_cta(cta_config)
        }
    }

    renderFieldMaps = () => {
        if(this.getEnableState()) {
            return (
                <div style = {{width : '100%', padding : '5px'}}>
                    <Typography style = {{display : 'block', marginBottom : '10px'}} variant = 'subtitle2'>Field Maps</Typography>
                    {this.getFieldMaps().map((field, i) => {
                        return (
                            <Paper key = {i} square style = {{width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px', marginBottom : '10px'}}>
                                <div style = {{width : '25%', padding : '5px'}}>
                                    <TextField
                                        fullWidth
                                        id="cta-field-name"
                                        label="Field Name"
                                        variant="filled"
                                        value = {field.field_name}
                                        onChange = {(event) => this.handleFieldNameChange(field.id, event)}
                                        helperText = "Give a unique field name without 'space' and '&'"
                                        error = {field.field_name === "" ? true : false}
                                        size = 'small'
                                        disabled = {!this.props.edit}
                                    />
                                </div>
                                <div style = {{width : '25%', padding : '5px'}} disabled = {!this.props.edit}>
                                    <FormControl variant = 'filled' fullWidth size='small'>
                                        <InputLabel id="cta-field-source">Source</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select-label"
                                            value={field.source}
                                            onChange={(event) => this.handleSource(field.id, event)}
                                        >
                                            {this.getSourceOptions().map(option => {
                                                return (
                                                    <MenuItem value={option.value}>{option.label}</MenuItem>
                                                )
                                            })}
                                        </Select>
                                        <FormHelperText>Select the source.</FormHelperText>
                                    </FormControl>
                                </div>
                                <div style = {{width : '45%', padding : '5px'}}>
                                    {field.source !== "" && this.renderFieldOptions(field.source, field)}
                                </div>
                                <div style = {{width : '5%'}}>
                                    <IconButton 
                                        color = "secondary"
                                        onClick = {() => this.deleteFieldMap(field.id)}
                                        disabled = {!this.props.edit}
                                    >
                                        <Clear fontSize='small'/>
                                    </IconButton>
                                </div>
                            </Paper>
                        )
                    })}
                    <Button
                        style = {{marginTop: '10px'}}
                        variant = 'contained'
                        color = 'primary'
                        size = 'small'
                        onClick = {this.addFieldMap}
                        disabled = {!this.props.edit}
                    >Add Field</Button>
                </div>
            )
        } else {
            return (
                <ThemeProvider theme={blue_theme}>
                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "180px"}}>
                    <Typography color="secondary" variant="caption"> Call to Action is not enabled </Typography>
                  </div>
                </ThemeProvider>
            );
        }
        
    }

    handleFieldNameChange = (field_id, event) => {
        if (this.state.main_tab_index === 0) {
 
        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])

            let iu_cta_obj = cta_config[ic_cta_index].iu[iu_cta_index]
            let field_map_index = iu_cta_obj.fields.findIndex(field => field.id === field_id)

            cta_config[ic_cta_index].iu[iu_cta_index].fields[field_map_index].field_name = event.target.value

            this.props.set_cta(cta_config)
        } 
    }

    getFieldMaps = () => {
        if (this.state.main_tab_index === 0) {

        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])

            return cta_config[ic_cta_index].iu[iu_cta_index].fields
        }
    }

    getSourceOptions = () => {
        let options = []

        if (this.props.screen_config.component === 'queue') {
            if (this.state.main_tab_index === 0) {

            } else {
                options = [
                    {
                        label : "Native Raw Field",
                        value : "native.raw_field" 
                    },
                    {
                        label : "Native World View",
                        value : "native.world_view" 
                    },
                    {
                        label : "External Raw Field",
                        value : "external.raw_field" 
                    },
                    {
                        label : "Custom Static Value",
                        value : "custom.static" 
                    }
                ]
            }
        } else if (this.props.screen_config.component === 'search') {
            if (this.state.main_tab_index === 0) {

            } else {
                options = [
                    {
                        label : "Native Raw Field",
                        value : "native.raw_field" 
                    },
                    {
                        label : "Native World View",
                        value : "native.world_view" 
                    },
                    {
                        label : "Custom Static Value",
                        value : "custom.static" 
                    }
                ]
            }
        }

        return options
    }

    handleSource = (field_id, event) => {
        if (this.state.main_tab_index === 0) {

        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])

            let iu_cta_obj = cta_config[ic_cta_index].iu[iu_cta_index]
            let field_map_index = iu_cta_obj.fields.findIndex(field => field.id === field_id)

            cta_config[ic_cta_index].iu[iu_cta_index].fields[field_map_index].source = event.target.value
            cta_config[ic_cta_index].iu[iu_cta_index].fields[field_map_index].mapped_to = ""
            this.props.set_cta(cta_config) 
        }       
    }

    addFieldMap = () => {
        if (this.state.main_tab_index === 0) {

        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])

            let field_map = {
                id : uuidv4(),
                field_name : "",
                source : "",
                mapped_to : ""
            }

            cta_config[ic_cta_index].iu[iu_cta_index].fields.push(field_map)
            console.log("CTA Screen :: Adding Field map : ", cta_config)
            this.props.set_cta(cta_config)
        }
    }

    deleteFieldMap = (field_id) => {
        if (this.state.main_tab_index === 0) {

        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])

            let iu_cta_obj = cta_config[ic_cta_index].iu[iu_cta_index]
            let field_map_index = iu_cta_obj.fields.findIndex(field => field.id === field_id)

            cta_config[ic_cta_index].iu[iu_cta_index].fields.splice(field_map_index, 1)
            this.props.set_cta(cta_config)
        }
    }

    renderFieldOptions = (field_source, field) => {
        if (field_source === 'custom.static') {
            return (
                <TextField
                    fullWidth
                    id="cta-static-field-value"
                    label="Static Value"
                    variant="filled"
                    value = {field.mapped_to}
                    onChange = {(event) => this.handleFieldOptions(field.id, event)}
                    helperText = "Add a custom static value."
                    error = {field.mapped_to === "" ? true : false}
                    size = 'small'
                    disabled = {!this.props.edit}
                />
            )
        } else {
            return (
                <FormControl variant = 'filled' fullWidth size='small' disabled = {!this.props.edit}>
                    <InputLabel id="cta-field-source">Map to Field</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select-label"
                        value={field.mapped_to}
                        onChange={(event) => this.handleFieldOptions(field.id, event)}
                    >
                        {this.getFieldOptions(field.source).map(option => {
                            return (
                                <MenuItem value={option}>{option}</MenuItem>
                            )
                        })}
                    </Select>
                    <FormHelperText>Select the source.</FormHelperText>
                </FormControl>
            )
        }
    }

    getFieldOptions = (field_source) => {
        if (this.state.main_tab_index === 0) {

        } else {
            let source = field_source.split('.')[0]
            let field_type = field_source.split('.')[1]

            if (source === 'native') {
                let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
                let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
                let iu_name = iu_list[this.state.iu_tab_index]
                let iu_obj = this.props.ic_list.find(ic => ic.name === ic_name).information_units.find(iu => iu.name === iu_name)
                let options = []
                if (field_type === 'raw_field') {
                    options = iu_obj.fields_in_scope.map(field => field.name)
                } else if (field_type === 'world_view') {
                    options = iu_obj.iu_world_view.world_view_fields.map(field => field.name)
                }

                return options
            } else if (source === 'external') {
                let ic_name = this.props.external_ic
                let iu_name = this.props.external_iu

                let iu_obj = this.props.ic_list.find(ic => ic.name === ic_name).information_units.find(iu => iu.name === iu_name)
                let options = []
                if (field_type === 'raw_field') {
                    options = iu_obj.fields_in_scope.map(field => field.name)
                }

                return options
            }
        }
    }

    handleFieldOptions = (field_id, event) => {
        if (this.state.main_tab_index === 0) {

        } else {
            let cta_config = [...this.props.cta_config]
            let ic_cta_index = cta_config.findIndex(ic => ic.ic_name === this.props.selected_ic_list[this.state.ic_tab_index])
            let ic_name = this.props.selected_ic_list[this.state.ic_tab_index]
            let iu_list = this.props.ic_list.find(ic => ic.name === ic_name).information_units.map(iu => iu.name)
            let ic_cta_config = cta_config[ic_cta_index]
            let iu_cta_index = ic_cta_config.iu.findIndex(iu => iu.iu_name === iu_list[this.state.iu_tab_index])

            let iu_cta_obj = cta_config[ic_cta_index].iu[iu_cta_index]
            let field_map_index = iu_cta_obj.fields.findIndex(field => field.id === field_id)

            cta_config[ic_cta_index].iu[iu_cta_index].fields[field_map_index].mapped_to = event.target.value
            this.props.set_cta(cta_config) 
        }
    }

    renderMainTabContent = () => {
        switch(this.state.main_tab_index){
            case 0: 
                return this.renderCTAConfig()
            case 1:
                return this.renderTabs()
            default:
                return null
        }
    }

    renderMainTabs = () => {
        return (
            <div>
                <AntTabs
                    key = 'main_tab'
                    value={this.state.main_tab_index}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.handleMainTabChange}
                    aria-label="Display Config Tabs"
                >
                    <AntTab label = 'Screen'/>
                    <AntTab label = 'Information Channel'/>
                </AntTabs>
                {this.renderMainTabContent()}
            </div>
        )
    }

    render() { 
        console.log("CTA Screen :: Screen Config :: ", this.props.screen_config)
        console.log("CTA Screen :: IC List :: ", this.props.ic_list)
        console.log("CTA Screen :: Selected IC List :: ", this.props.selected_ic_list)
        console.log("CTA Screen :: Config ", this.props.cta_config)
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100%', padding : '5px'}}>
                    <Typography style = {{display : 'block'}} variant = 'subtitle2'>Call To Action</Typography>
                    <Divider style = {{marginTop : '5px', marginBottom : '5px'}}/>
                    {this.renderMainTabs()}
                </div>    
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(CTAConfig);